import React, { useState, lazy } from 'react';
import styles from '../styles/findMyfriends.module.css';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PhoneVerificationComponent = lazy(() => import('../../../components/sharedComponents/PhoneVerification'));


const FindMyFriendsHero = () => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");

    const [toggleSearchInput, setToggleSearchInput] = useState(true);

    const togglePhoneVerificationPopup = (e) => {
        e.preventDefault();
        setToggleSearchInput(!toggleSearchInput);
    }

    return (
        <section>
            <div className={styles.heroBgImage}>
                <div className={styles.homeHeroInnerContainer}>
                    <div className='maxScreen'>
                        {!isAboveMediumScreens && <div className={styles.emptyContainer}></div>}
                        <div className={styles.heroContainer}>
                            <h1 className={styles.heading}><span className="hightLightText">Stay In The Loop</span>
                                <br></br>With The World’s  #1<br></br>Find My Friends App</h1>
                            <p className={styles.paragraph}>
                                You already share everything, now share your location too.<br></br>
                                Stay safe and organised with our location sharing app for friends. </p>
                            <br />
                            <br />
                            <div className='inputContainer'>
                                {toggleSearchInput && <PhoneVerificationComponent showPopUp={togglePhoneVerificationPopup} />}
                            </div>

                        </div>
                        <div className={styles.emptyContainer}></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FindMyFriendsHero;